import React from 'react';
import {
  View,
  Text,
  Image,
  // Platform,
  // TouchableOpacity,
} from 'react-native';
import Svg, {
  Circle,
  // Text as SvgText,
} from 'react-native-svg';
import PropTypes from 'prop-types';
// import { translate } from '../../locales/i18n';
import AORTypes from '../../types';
import styles from '../../styles';
import Endpoint from '../../modules/data/Endpoint';
// import { AudioMiniPlayer } from '../../audio-player';
import Uploader from '../../Uploader';

// import camera from '../../assets/images/antwerp.jpg';
// import play from '../../assets/images/glyphicons-play.png';
import none from '../../assets/images/glyphicons-alert.png';
import Pen from '../../assets/images/pen.svg';

import infraConfig from '../../config.json';

class EndpointBadge extends React.Component {
  static getImage(image) {
    if (image.thumb) {
      return { uri: image.thumb };
    }

    return EndpointBadge.getImageReal(image);
  }

  static getImageReal(image) {
    const str = image.uuid;
    // FIXME(clairbee): why 8 6 4 2, and not 2 2 2 2 ???
    const prefix = str.substring(6, 8)
      + str.substring(4, 6)
      + str.substring(2, 4)
      + str.substring(0, 2);
    // const prefix = data.uuid.substring(0, 8);
    // console.log(prefix);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return { uri: `https://${infraConfig.imagesThumbsBucket}.s3-${infraConfig.region}.amazonaws.com/${index}/${image.uuid}` };
  }

  constructor(props, context) {
    super(props, context);

    this.updateUrl = this.updateUrl.bind(this);

    this.state = {
      url: null,
    };
  }

  componentDidMount() {
    this.updateUrl(this.state);
  }

  componentDidUpdate(_prevProps, prevState) {
    this.updateUrl(prevState);
  }

  updateUrl(prevState) {
    const { endpoint, userData } = this.props; // Pass the endpoint in instead of data

    if (endpoint.data && endpoint.data.track) {
      if (prevState.urlTrack !== endpoint.data.track) {
        if (endpoint.isFullTrackAccessible(userData !== null ? userData.uuid : 'none')) {
          Uploader.getToken().then((token) => {
            const url = endpoint.getTrackPublisher(token);

            // console.log('setting the playlist for the full track');
            // console.log(url);

            this.setState({ urlTrack: endpoint.data.track, url });
          });
        } else {
          const url = endpoint.getTrackPreview();

          // console.log('setting the playlist for the preview track');
          // console.log(url);

          this.setState({ urlTrack: endpoint.data.track, url });
        }
      }
    } else if (prevState.urlTrack !== '') {
      this.setState({ urlTrack: '', url: null });
    }
  }

  render() {
    const {
      idx,
      endpoint,
      // getAnalyticsService,
      edit,
      selected,
      single,
    } = this.props;
    const {
      url,
    } = this.state;

    endpoint.postProcess();

    return (
      // <TouchableOpacity
      //   style={[styles.endpointBadge.panel, {
      //     flex: 1,
      //     flexDirection: 'column',
      //     marginHorizontal: 0,
      //   }]}
      //   onPress???={ /* needs a ref from the MiniPlayer and a way to trigger it */ }
      // >
      <View
        style={[styles.endpointBadge.panel, {
          borderWidth: selected ? 1 : 0,
          borderColor: selected ? styles.primaryColor : '#ffffff',
          backgroundColor: selected ? '#f0f0f0' : '#ffffff',
        }]}
        onPress={() => {
          console.log('pressed');
        }}
      // itemProp="includesAttraction"
      // itemType="https://schema.org/ConsumerAttraction"
      // itemScope
      >
        {/* SEO tags */}
        {/* {Platform.OS === 'web' && (
          <>
            <meta itemProp="name" content={endpoint.data.name} />
            <View itemProp="geo" itemType="https://schema.org/GeoCoordinates" itemScope>
              <meta itemProp="latitude" content={endpoint.data.lat} />
              <meta itemProp="longitude" content={endpoint.data.lon} />
            </View>
            <meta itemProp="publicAccess" content="true" />
            {endpoint.pp.images.length > 0 && endpoint.pp.images.map((image) => (
              <link
                itemProp="image"
                href={EndpointBadge.getImageReal(image)}
              />
            ))}
          </>
        )} */}

        {!single && (
          <View style={styles.endpointBadge.blockPoint}>
            <Svg height="100%" width="100%" viewBox="0 0 40 40">
              <Circle
                cx="20"
                cy="20"
                r="12"
                fill={styles.primaryColor}
              />
              <Circle
                cx="20"
                cy="20"
                r="9"
                fill="#ffffff"
              />
              {selected && (
                <Circle
                  cx="20"
                  cy="20"
                  r="6"
                  fill={styles.primaryColor}
                />
              )}
            </Svg>
          </View>
        )}
        <View style={endpoint.pp.images.length > 0 ? styles.endpointBadge.panelInnerWithImages : styles.endpointBadge.panelInner}>
          <View style={styles.endpointBadge.namePanel}>
            <View
              style={{
                flex: 1,
              }}
            >
              <Text style={styles.endpointBadge.name} numberOfLines={1}>
                {endpoint.data.name}
              </Text>
              <Text style={styles.endpointBadge.desc}>
                {endpoint.data.desc}
              </Text>
            </View>
            {edit && (
              <Pen
                style={{
                  width: 14,
                  height: 14,
                  alignSelf: 'center',
                }}
              />
            )}
          </View>
        </View>
        {/* <View style={styles.endpointBadge.blockPlay}>
          {url !== null && (
            <Image style={styles.endpointBadge.play} source={none} />
          )}
        </View> */}
      </View>
    );
  }
}

EndpointBadge.defaultProps = {
  userData: null,
  // onTrackComplete: () => undefined,
  edit: false,
  selected: false,
  single: false,
};

EndpointBadge.propTypes = {
  userData: AORTypes.User,
  endpoint: PropTypes.instanceOf(Endpoint).isRequired,
  idx: PropTypes.number.isRequired,
  // getAnalyticsService: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  selected: PropTypes.bool,
  single: PropTypes.bool,
};

export default EndpointBadge;
